$(document).ready(function () {

  $('.menu-item-has-children').on('mouseover', function () {
    $(this).addClass('menu-item-opened');
  });

  $('.menu-item-has-children').on('mouseleave', function () {
    $(this).removeClass('menu-item-opened');
  });

});



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/DropdownMenu.js